export class State {
  public opening: boolean;
  public windowHeight: number;
  public windowWidth: number;
  constructor() {
    this.opening = false;
    this.windowHeight = 1024;
    this.windowWidth = 1024;
  }
}

const state = new State();

export default state;
